export default "__VITE_ASSET__CXHJ6uVi__"